import React, { useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hidePersonalJackpotNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import PersonalJackpotPolling from './PersonalJackpotPolling/PersonalJackpotPolling'

const PersonalJackpotNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const personalJackpotNotify = useSelector(selectNotifies, shallowEqual).personalJackpot

  const [termporarilyClosedJackpots, setTemporarilyClosedJackpots] = useState<number[]>([])

  const hideJackpot = (id: number) => {
    dispatch(hidePersonalJackpotNotify(id))
  }

  const temporarilyHideNotify = (id: number) => {
    setTemporarilyClosedJackpots(prev => [...prev, id])
  }

  const items = useMemo(
    () =>
      Object.keys(personalJackpotNotify.all)
        .filter(
          jackpotId =>
            !personalJackpotNotify.hide.includes(+jackpotId) && !termporarilyClosedJackpots.includes(+jackpotId),
        )
        .map(jackpot => {
          const currId = Number(jackpot)
          const row = personalJackpotNotify.all[currId]

          return (
            <NotifyContainer
              key={jackpot}
              title={locale.yourJackpot}
              value={String(row?.amount)}
              currency={row.amountCurrency}
              callback={() => hideJackpot(currId)}
              hideTemporarily={() => temporarilyHideNotify(currId)}
            />
          )
        }),
    [personalJackpotNotify, termporarilyClosedJackpots, locale],
  )

  return (
    <>
      {isAuth ? <PersonalJackpotPolling /> : null}
      {items}
    </>
  )
}

export default PersonalJackpotNotify
